// AI-CONTEXT: See docs/features/arbeidsvaardigheden.md
//
// De vastgestelde lijst van MSI Arbeidsvaardigheden 0.9. GEGENEREERD —
// niet met de hand bijwerken. Regenereren: tools/genereer-arbeidsvaardigheden.py
//
// Elke stelling is een tegenpolenpaar, letterlijk uit het Formulier
// arbeidsvaardigheden Werkbedrijf Nijmegen 0.9: een positieve pool links, de
// negatieve rechts, en de begeleider zet de deelnemer daartussen. Twee
// stellingen (EFF-09 #3 en #4) hebben in het formulier geen tegenpool en
// krijgen er hier ook geen; `rechts` is dan null.
//
// Wij slaan de Likert-score op, niet de kolomindex: 5 hoort bij de LINKERpool
// (de gunstige kant), 1 bij de rechter. Dat volgt de standaard, waarin 5
// positief is en 4 het nulpunt. Wie de kolommen andersom rendert, moet de
// waarde omrekenen en niet de betekenis van de score verschuiven.
//
// Vijf van de 46 stellingen tellen NIET mee in de effectscore (richting
// 'geen'). Hun positieve pool is normatief niet houdbaar — behoefte aan
// structuur of uiterlijke verzorging is een kenmerk, geen tekortkoming. Ze
// worden wel uitgevraagd en zijn zichtbaar voor de begeleiding.

export const STANDAARD_VERSIE = "0.9"

// De schaal loopt van 1 (sterk negatief) tot 5 (positief); 4 is het nulpunt.
export const LIKERT_NIVEAUS = [1, 2, 3, 4, 5]

export const EFFECTEN = [
    {
        id: "EFF-01",
        uid: "arbeidsvaardigheden:zelfstandigheid-en-kwaliteit",
        slug: "zelfstandigheid-en-kwaliteit",
        naam: "Zelfstandigheid en kwaliteit",
        definitie: "De mate waarin de deelnemer werkzaamheden zonder begeleiding en zonder controle uitvoert, zelf problemen oplost, overziet wat er moet gebeuren, uit zichzelf begint en werk van voldoende kwaliteit levert waarbij fouten worden opgemerkt.",
        stellingen: [
            {
                nummer: 1,
                links: "Heeft geen begeleiding nodig",
                rechts: "Heeft veel begeleiding nodig",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 2,
                links: "Hoeft niet gecontroleerd te worden",
                rechts: "Moet door de begeleiding gecontroleerd worden",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 3,
                links: "Lost problemen zelfstandig op",
                rechts: "Lost zelf geen problemen op",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 4,
                links: "Overziet wat er moet gebeuren, wat belangrijk is",
                rechts: "Overziet niet wat er moet gebeuren",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 5,
                links: "Het werk is kwalitatief goed",
                rechts: "Het werk is kwalitatief onvoldoende",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 6,
                links: "Ziet fouten",
                rechts: "Ziet geen fouten",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 7,
                links: "Begint uit zichzelf aan werkzaamheden",
                rechts: "Begint niet uit zichzelf aan werkzaamheden",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 8,
                links: "Wacht niet af bij einde taak",
                rechts: "Is afwachtend bij einde taak",
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
    {
        id: "EFF-02",
        uid: "arbeidsvaardigheden:leerbaarheid-en-motivatie",
        slug: "leerbaarheid-en-motivatie",
        naam: "Leerbaarheid en motivatie",
        definitie: "De mate waarin de deelnemer nieuwe werkzaamheden aanleert, genoeg heeft aan eenmalige uitleg, inzicht heeft in het waarom van een taak, en gemotiveerd is voor huidige en nieuwe werkzaamheden.",
        stellingen: [
            {
                nummer: 1,
                links: "Leert gemakkelijk nieuwe werkzaamheden aan",
                rechts: "Heeft moeite met aanleren nieuwe werkzaamheden",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 2,
                links: "Heeft genoeg aan eenmalige uitleg",
                rechts: "Heeft veel herhaling nodig",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 3,
                links: "Heeft genoeg aan mondelinge uitleg",
                rechts: "Heeft visualisatie nodig",
                richting: "geen",
                teltMeeInScore: false,
            },
            {
                nummer: 4,
                links: "Heeft inzicht in taak",
                rechts: "Heeft geen inzicht in taak",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 5,
                links: "Is gemotiveerd voor huidige werkzaamheden",
                rechts: "Is niet gemotiveerd voor huidige werkzaamheden",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 6,
                links: "Is gemotiveerd voor nieuwe werkzaamheden",
                rechts: "Is niet gemotiveerd voor nieuwe werkzaamheden",
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
    {
        id: "EFF-03",
        uid: "arbeidsvaardigheden:tempo-en-energie",
        slug: "tempo-en-energie",
        naam: "Tempo en energie",
        definitie: "De mate waarin de deelnemer snel en op tijd klaar is, voldoende energie heeft voor de werkdag, aaneengesloten kan doorwerken, een regelmatig tempo houdt en tempodruk aankan.",
        stellingen: [
            {
                nummer: 1,
                links: "Werkt snel, is op tijd klaar",
                rechts: "Werkt langzaam",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 2,
                links: "Heeft voldoende energie",
                rechts: "Heeft weinig energie / vaak pauze nodig",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 3,
                links: "Kan 1 uur aaneengesloten werken",
                rechts: "Kan niet 1 uur aandacht bij werk houden",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 4,
                links: "Heeft een regelmatig tempo",
                rechts: "Heeft een onregelmatig tempo",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 5,
                links: "Kan druk op tempo aan",
                rechts: "Kan druk op tempo niet aan",
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
    {
        id: "EFF-04",
        uid: "arbeidsvaardigheden:handigheid",
        slug: "handigheid",
        naam: "Handigheid",
        definitie: "De mate waarin de deelnemer soepel beweegt bij tillen, bukken en staan, nauwkeurig werkt met de handen, kracht kan doseren, veilig omgaat met machines en apparaten, en ordelijk en netjes werkt.",
        stellingen: [
            {
                nummer: 1,
                links: "Heeft een goede grove motoriek",
                rechts: "Heeft een slechte grove motoriek",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 2,
                links: "Heeft een goede fijne motoriek",
                rechts: "Heeft een slechte fijne motoriek",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 3,
                links: "Kan kracht doseren",
                rechts: "Kan kracht niet doseren",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 4,
                links: "Gaat veilig/goed om met apparaten",
                rechts: "Kan niet veilig/goed omgaan met apparaten",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 5,
                links: "Werkt ordelijk en netjes",
                rechts: "Werkt chaotisch en slordig",
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
    {
        id: "EFF-05",
        uid: "arbeidsvaardigheden:omgaan-met-verandering-en-spanning",
        slug: "omgaan-met-verandering-en-spanning",
        naam: "Omgaan met verandering en spanning",
        definitie: "De mate waarin de deelnemer kan omgaan met veranderingen, rustig blijft bij tegenslag en een stabiele stemming heeft tijdens het werk.",
        stellingen: [
            {
                nummer: 1,
                links: "Heeft geen behoefte aan structuur",
                rechts: "Heeft behoefte aan structuur",
                richting: "geen",
                teltMeeInScore: false,
            },
            {
                nummer: 2,
                links: "Kan tegen veranderingen",
                rechts: "Kan niet tegen veranderingen",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 3,
                links: "Blijft rustig in lastige situaties / bij tegenvallers",
                rechts: "Wordt onrustig in lastige situaties / bij tegenvallers",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 4,
                links: "Heeft geen stemmingswisselingen",
                rechts: "Wisselt vaak van stemming",
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
    {
        id: "EFF-06",
        uid: "arbeidsvaardigheden:concentratie-en-taakwisseling",
        slug: "concentratie-en-taakwisseling",
        naam: "Concentratie en taakwisseling",
        definitie: "De mate waarin de deelnemer overschakelt naar een volgende taak, een opdracht tussendoor aankan, en zich kan concentreren bij zowel enkelvoudige als meerstaps opdrachten.",
        stellingen: [
            {
                nummer: 1,
                links: "Schakelt gemakkelijk over naar de volgende taak",
                rechts: "Schakelt moeilijk over naar de volgende taak",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 2,
                links: "Kan opdrachten tussendoor aan",
                rechts: "Kan geen opdrachten tussendoor aan",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 3,
                links: "Kan aan 2 of meer taken tegelijk werken",
                rechts: "Kan aan 1 taak tegelijk werken",
                richting: "geen",
                teltMeeInScore: false,
            },
            {
                nummer: 4,
                links: "Kan zich concentreren bij enkelvoudige opdracht",
                rechts: "Kan zich niet concentreren / snel afgeleid",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 5,
                links: "Kan zich concentreren bij meervoudige opdracht",
                rechts: "Kan zich niet concentreren / snel afgeleid",
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
    {
        id: "EFF-07",
        uid: "arbeidsvaardigheden:samenwerking",
        slug: "samenwerking",
        naam: "Samenwerking",
        definitie: "De mate waarin de deelnemer samenwerkt, bij verschillende belangen een goede afweging maakt, collega's helpt, om hulp vraagt en kan omgaan met kritiek in beide richtingen.",
        stellingen: [
            {
                nummer: 1,
                links: "Kan samenwerken",
                rechts: "Kan niet samenwerken",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 2,
                links: "Kan bij belangen juiste afweging maken",
                rechts: "Kan niet de juiste afweging maken (kwetsbaar)",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 3,
                links: "Is behulpzaam",
                rechts: "Is niet behulpzaam",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 4,
                links: "Stelt hulpvragen",
                rechts: "Stelt geen hulpvragen",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 5,
                links: "Kan omgaan met kritiek (geven en ontvangen)",
                rechts: "Kan niet omgaan met kritiek",
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
    {
        id: "EFF-08",
        uid: "arbeidsvaardigheden:betrouwbaarheid",
        slug: "betrouwbaarheid",
        naam: "Betrouwbaarheid",
        definitie: "De mate waarin de deelnemer op tijd komt, zich houdt aan pauzetijden en bedrijfsregels, en gemaakte afspraken nakomt.",
        stellingen: [
            {
                nummer: 1,
                links: "Komt op tijd",
                rechts: "Komt niet op tijd",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 2,
                links: "Houdt zich aan pauzetijden",
                rechts: "Houdt zich niet aan pauzetijden",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 3,
                links: "Houdt zich aan bedrijfsregels",
                rechts: "Houdt zich niet aan bedrijfsregels",
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 4,
                links: "Komt afspraken na",
                rechts: "Komt afspraken niet na",
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
    {
        id: "EFF-09",
        uid: "arbeidsvaardigheden:presentatie-en-contact",
        slug: "presentatie-en-contact",
        naam: "Presentatie en contact",
        definitie: "De mate waarin de deelnemer contact legt met collega's en met mensen van buiten het bedrijf.",
        stellingen: [
            {
                nummer: 1,
                links: "Ziet er schoon en verzorgd uit",
                rechts: "Ziet er niet schoon en verzorgd uit",
                richting: "geen",
                teltMeeInScore: false,
            },
            {
                nummer: 2,
                links: "Kan zich goed presenteren",
                rechts: "Kan zich niet goed presenteren",
                richting: "geen",
                teltMeeInScore: false,
            },
            {
                nummer: 3,
                links: "Contactvaardigheid met collega’s",
                rechts: null,
                richting: "positief",
                teltMeeInScore: true,
            },
            {
                nummer: 4,
                links: "Contactvaardigheid met derden",
                rechts: null,
                richting: "positief",
                teltMeeInScore: true,
            },
        ],
    },
]

export const effectVoorId = id => EFFECTEN.find(e => e.id === id) ?? null

// 46 uitgevraagd, 41 scorend. Die twee getallen horen uit elkaar te lopen;
// zie de opmerking bovenaan.
export const AANTAL_STELLINGEN = EFFECTEN.reduce((n, e) => n + e.stellingen.length, 0)
export const AANTAL_SCOREND = EFFECTEN.reduce(
    (n, e) => n + e.stellingen.filter(s => s.teltMeeInScore).length,
    0
)
